<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            path: '/admin/dashboard',
            icon: 'ni ni-tv-2 text-purple',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Agências',
            path: '/admin/agencias',
            icon: 'ni ni-building text-danger',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Peças Publicitárias',
            path: '/admin/pecas-publicitarias',
            icon: 'ni ni-single-copy-04 text-danger',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Estudantes',
            path: '/admin/estudantes',
            icon: 'ni ni-hat-3 text-info',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Peças Estudantes',
            path: '/admin/pecas-estudantes',
            icon: 'ni ni-single-copy-04 text-info',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Resposta de Jurado',
            path: '/admin/jurado-resposta',
            icon: 'ni ni-badge text-purple',
          }"
        >
        </sidebar-item>
      </template>

      <template slot="links-after">
        <sidebar-item
          :link="{
            name: 'Categoria Peça Publicitária',
            path: '/admin/categoria-peca-publicitaria',
            icon: 'ni ni-bullet-list-67 text-danger',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Categoria Peça Estudante',
            path: '/admin/categoria-peca-estudante',
            icon: 'ni ni-bullet-list-67 text-warning',
          }"
        >
        </sidebar-item>
      </template>

      <template slot="links-legado">
        <sidebar-item
          :link="{
            name: 'Indicação de Profissionais (legado)',
            path: '/admin/profissionais',
            icon: 'ni ni-briefcase-24 text-success',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Profissionais Independentes (legado)',
            path: '/admin/profissional-independente',
            icon: 'ni ni-briefcase-24 text-success',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Peças de Profissionais Independentes (legado)',
            path: '/admin/pecas-profissional-independente',
            icon: 'ni ni-single-copy-04 text-success',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Fornecedores (legado)',
            path: '/admin/fornecedores',
            icon: 'ni ni-bag-17 text-warning',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Peças Fornecedores (legado)',
            path: '/admin/pecas-fornecedores',
            icon: 'ni ni-single-copy-04 text-warning',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Categoria Peça Fornecedor (legado)',
            path: '/admin/categoria-peca-fornecedor',
            icon: 'ni ni-bullet-list-67 text-warning',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Categoria Peça Profissional Independente (legado)',
            path: '/admin/categoria-peca-profissional-independente',
            icon: 'ni ni-bullet-list-67 text-warning',
          }"
        >
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
  },
  mounted() {
    this.initScrollbar();
  },
};
</script>
<style lang="scss">
.navbar-collapse .navbar-toggler span {
  background: white;
}
</style>
